import React from "react";
import CommonCarousel from "../carousel/CommonCarousel";
import MainMovieCarousel from "../carousel/MainMovieCarousel";
import TrendingToday from "../carousel/TrendingToday";
import Genere from "../Genere/Genere";
import Header from "../Header/Header";

const Home = (props) => {
  return (
    <React.Fragment>
      <Header {...props} />
      <div className="main Home-container bg-white slide-animation">
        <MainMovieCarousel {...props} dataUrl="https://api.themoviedb.org/3/movie/popular" />
        <Genere />
        {/* // the dataUrl is the link of data you want to fetch and the genere is the name of the section
         //  Like trending, action genere
      */}
        <CommonCarousel {...props} genere="Trending" dataUrl="https://api.themoviedb.org/3/trending/all/day" color="g5-blue" />
        <CommonCarousel {...props} genere="now playing" dataUrl="https://api.themoviedb.org/3/movie/now_playing" color="g5-orange" />
        <TrendingToday {...props} dataUrl="https://api.themoviedb.org/3/trending/all/day" color="g5-high-carolina"
          genere="Trending Today" />
      </div>
    </React.Fragment>
  );
};

export default Home;

/** These are the color parameters you can pass
 *  Colors are coded in global.scss file with same class name

  g5-red
  g5-blue
  g5-orange
  g5-carolina
  g5-steelblue
  g5-high-carolina
  g5-high-olive

 */